import naja from "naja";
window.naja = naja;
